module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voices-2-20dd1bbd87f98b1efbe7d3f6838d5e4c.png";